import { Component, inject, input, OnInit } from '@angular/core';
import { Permissions } from '../../../../constants/permissions';
import {
  IAnalogIOExtenderList,
  IGen2IOExtenderList,
  INormalIOExtenderList,
} from '../../../../models/io-extender';
import { Auth } from '../../../../services/auth';
import { AnalogIo } from './analog-io/analog-io';
import { Gen2Io } from './gen2-io/gen2-io';
import { NormalIo } from './normal-io/normal-io';

@Component({
  selector: 'app-io-addon-view',
  imports: [NormalIo, AnalogIo, Gen2Io],
  templateUrl: './io-addon-view.html',
  styleUrl: './io-addon-view.css',
})
export class IoAddonView implements OnInit {
  normalExtenders = input.required<INormalIOExtenderList | null>();
  analogExtenders = input.required<IAnalogIOExtenderList | null>();
  gen2Extenders = input.required<IGen2IOExtenderList | null>();
  isLoading = input.required<boolean>();
  readonly authService = inject(Auth);
  readonly permissions = Permissions;

  hasPermission(permission: Permissions): boolean {
    return this.authService.hasPermission(permission);
  }

  ngOnInit(): void {}
}
